type Surface = {
  primary: string
  input: string
}

type Other = {
  backdrop: string
  outlineBorder: string
  disabled: string
  divider: string
}

declare module '@mui/material/styles' {
  // デフォルトのpalette colorに独自のものを追加
  interface Palette {
    white: string
    surface: Surface
    other: Other
  }
  // デフォルトのpalette colorに独自のものを追加
  interface PaletteOptions {
    white: string
    surface: Surface
    other: Other
  }
  // PaletteColorのtokenに独自のものを追加(全てのpalette colorに下記のtokenを追加しているわけではないのでoptional)
  interface PaletteColor {
    toridoriMain?: string
    '4p'?: string
    '160p'?: string
    '190p'?: string
    outlineBorder?: string
  }
  // PaletteColorのtokenに独自のものを追加(全てのpalette colorに下記のtokenを追加しているわけではないのでoptional)
  interface SimplePaletteColorOptions {
    toridoriMain?: string
    '4p'?: string
    '160p'?: string
    '190p'?: string
    outlineBorder?: string
  }
  // textのtokenに独自のものを追加
  interface TypeText {
    placeholder: string
    invertPrimary: string
  }
  // backgroundのtokenに独自のものを追
  interface TypeBackground {
    main: string
  }
}

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    white: true
  }
}

export const colorPalette = {
  white: '#FFFFFF', // TODO: 消してこれの使用箇所をtext.invertPrimaryやbackground.mainに置き換える
  primary: {
    toridoriMain: 'rgba(0, 87, 183, 1)',
    main: 'rgba(25, 118, 210, 1)',
    dark: 'rgba(21, 101, 192, 1)',
    '4p': 'rgba(246, 250, 253, 1)',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.38)',
    placeholder: 'rgba(0, 0, 0, 0.38)',
    invertPrimary: 'rgba(255, 255, 255, 1)',
  },
  surface: {
    primary: 'rgba(250, 250, 250, 1)',
    input: 'rgba(0, 0, 0, 0.1)',
  },
  background: {
    main: 'rgba(255, 255, 255, 1)',
  },
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    selected: 'rgba(0, 0, 0, 0.08)',
    focus: 'rgba(0, 0, 0, 0.12)',
  },
  info: {
    main: 'rgba(25, 118, 210, 1)',
    outlineBorder: 'rgba(25, 118, 210, 1)',
    light: 'rgba(237,244,255,1)', // TODO: 将来的に削除予定。代わりに190pを使用してください。
    '160p': 'rgba(10, 47, 84, 1)',
    '190p': 'rgba(232, 241, 250, 1)',
  },
  success: {
    main: 'rgba(46, 125, 50, 1)',
    outlineBorder: 'rgba(46, 125, 50, 1)',
    light: 'rgba(247, 250, 247, 1)', // TODO: 将来的に削除予定。代わりに190pを使用してください。
    '160p': 'rgba(18, 50, 20, 1)',
    '190p': 'rgba(234, 242, 234, 1)',
  },
  warning: {
    main: 'rgba(237, 108, 2, 1)',
    outlineBorder: 'rgba(237, 108, 2, 1)',
    light: 'rgba(254, 249, 245, 1)', // TODO: 将来的に削除予定。代わりに190pを使用してください。
    '160p': 'rgba(95, 43, 1, 1)',
    '190p': 'rgba(253, 240, 230, 1)',
  },
  error: {
    main: 'rgba(211, 47, 47, 1)',
    outlineBorder: 'rgba(211, 47, 47, 1)',
    light: 'rgba(253, 247, 247, 1)', // TODO: 将来的に削除予定。代わりに190pを使用してください。
    '160p': 'rgba(84, 19, 19, 1)',
    '190p': 'rgba(251, 234, 234, 1)',
  },
  other: {
    backdrop: 'rgba(0, 0, 0, 0.5)',
    outlineBorder: 'rgba(0, 0, 0, 0.23)',
    disabled: 'rgba(0, 0, 0, 0.23)',
    divider: 'rgba(0, 0, 0, 0.12)',
  },
} as const
